var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderHoriz = function SvgOrderHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2812 1.68018V6.72018H9.24125V1.68018L14.2812 1.68018Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55859 1.68018V6.72018H2.51859V1.68018L7.55859 1.68018Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2793 8.3999V15.1199H12.5993V8.3999H14.2793Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9199 8.3999V15.1199H9.23992V8.3999H10.9199Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55953 8.3999V15.1199H5.87953V8.3999H7.55953ZM4.19953 8.3999V15.1199H2.51953V8.3999H4.19953Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2812 1.68018V6.72018H9.24125V1.68018L14.2812 1.68018Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56055 1.68018V6.72018H2.52055V1.68018L7.56055 1.68018Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2793 8.40039V15.1204H12.5993V8.40039H14.2793Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9199 8.40039V15.1204H9.23992V8.40039H10.9199Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55953 8.40039V15.1204H5.87953V8.40039H7.55953ZM4.19953 8.40039V15.1204H2.51953V8.40039H4.19953Z",
    fill: "currentColor"
  })))));
};
export default SvgOrderHoriz;